import React from 'react';
import EsgDropdown from '../../components/EsgDropdown';
import Percent_Bars from '../../components/Percent_Bars';

const EsgPage3 = () => {
  return (
    <div className="bg-white">
      <div className="md:px-24 px-4 md:pt-7 pt-3">
      <h1 className='md:text-[36px] text-[10px] font-bold text-[#FDBD26]'>GOVERNANCE</h1>
        <p className='md:text-[36px] text-[8px] font-normal md:mb-8 mb-1 md:mt-4 mt-1'>
        Farmers can participate in ESG (Environmental, Social, and Governance) activities through the FarmNet app
        </p>

        <div className="mx-auto flex  md:flex-row gap-1">
          {/* Environmental Participation */}
          <div className='w-full md:w-1/3'>
            <div className="bg-[#152C24] md:p-2  p-1 rounded mb-1">
              <h3 className="md:text-[16px] text-[6px] font-bold md:pl-5 text-[#FFFFFF] flex items-center">
              🌿 Environmental Participation
              </h3>
            </div>
            <div className="bg-[#2E453D] text-white md:p-4 p-2 md:pl-5 rounded-md border border-[#13483A] md:h-[350px]">
              <ul className="list-disc list-outside md:pl-6 pl-1 text-[5px] md:text-[15px] space-y-0">
                <li>
                  <strong>Climate-Smart Practices:</strong> FarmNet shares training and resources on conservation agriculture, organic input use, and agroforestry—helping farmers reduce their environmental footprint.
                </li>
                <li className=''>
                  <strong>Sustainable Resource Tracking:</strong> Farmers can log data on water usage, input application, and soil health<span className='md:flex hidden'>—promoting sustainable and traceable eco-friendly farming.</span>
                </li>
                <li  >
              <p  className='md:block hidden list-disc'>    <strong>Green Certification Support:</strong> The app can assist with data needed for sustainability certifications or climate finance programs (e.g., carbon credits or green supply chains).</p>
                </li>
              </ul>
            </div>
          </div>

          {/* Social Participation */}
          <div className='w-full md:w-1/3'>
            <div className="bg-[#152C24] md:p-2 p-1  rounded mb-1">
              <h3 className="md:text-[16px] text-[6px] text-white  font-bold  md:pl-5 flex items-center">
                🤝 Social Participation
              </h3>
            </div>
            <div className="bg-[#2E453D] text-white md:p-4 p-2 rounded-md border border-[#13483A] md:h-[350px]">
              <ul className="list-disc list-outside md:pl-6 pl-1 md:text-[15px] text-[5px] space-y-0">
                <li>
                  <strong>Inclusive Community Networks:</strong> FarmNet connects farmers into cooperatives and groups, promoting knowledge sharing, gender equity, and youth participation in agriculture.
                </li>
                <li>
                  <strong>Access to Services:</strong> Farmers get linked to health info, financial literacy training, and extension services <span className='md:flex hidden'>—contributing to overall community well-being.</span>
                </li>
                <li  >
          <p   className='md:block hidden' >      <strong>Transparency in Trade:</strong> The app facilitates fair trade by connecting farmers directly to markets, reducing exploitation and strengthening social justice.</p>
                </li>
              </ul>
            </div>
          </div>

          {/* Governance Participation */}
          <div className='w-full md:w-1/3'>
            <div className="bg-[#152C24] md:p-2 p-1 rounded mb-1">
              <h3 className="md:text-[16px] text-[6px] text-white  font-bold  md:pl-5 flex items-center">
                📊 Governance Participation
              </h3>
            </div>
            <div className="bg-[#2E453D] text-white md:p-4 p-2 rounded-md border border-[#13483A] md:h-[350px]">
              <ul className="list-disc list-outside md:pl-6 pl-1 text-[5px] md:text-[15px] space-y-0">
                <li>
                  <strong>Digital Records for Accountability:</strong> Farmers maintain transparent records of their practices and transactions, building trust with partners, buyers, and regulators.
                </li>
                <li>
                  <strong>Data-Driven Decision-Making:</strong> FarmNet empowers farmers to make smart choices using farm analytics,  <span className='md:flex hidden'>pricing data, and agronomic insights.</span>
                </li>
                <li>
            <p className='md:block hidden'>      <strong>Participation in Policy & Development Programs:</strong> With aggregated data, farmers can represent their interests better in discussions with development partners, NGOs, and government programs.</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      <h1 className='md:text-[36px] text-[10px] font-bold md:mt-11 mt-2 md:mb-5 text-[#FDBD26]'>ENVIRONMENTAL </h1>

        <div className="relative w-full h-[180px] md:h-[622px] rounded-[10px] overflow-hidden mb-6">
          <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745435238/image_25_xv0dir.png" alt="Community" className="w-full h-full object-cover" />
          <div className="absolute bottom-4 md:bottom-8 left-4 md:left-16 text-white">
            <h2 className="font-bold text-[12px] md:text-[32px]">Grow Together , Thrive Together</h2>
            <p className="text-[10px] md:text-[24px]">“Connecting Namibian farmers to knowledge, tools, and each other.”</p>
          </div>
        </div>
      <h1 className='md:text-[40px] text-[10px] font-bold md:mt-10 md:mb-5 text-[#FDBD26]'>GOVERNANCE </h1>

        <div className="md:mt-5 mt-2 max-w-screen-xl w-full">
            <div className="flex items-center gap-6 md:gap-8 text-[8px] md:text-[20px] font-normal text-black">
              <p>Story by Farmnet</p>
              <div className="flex items-center gap-2 text-[#155528]">
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743893169/Time_progress_light_ecbt3q.png"
                  alt="Clock"
                  className="h-3 w-3 md:h-8 md:w-8"
                />
                <p>28/04/2025</p>
              </div>
            </div>
          </div>
          <div className="text-black text-[14px] md:text-[30px] leading-relaxed">
          <h1 className=" text-black font-bold text-[12px] md:mt-5 md:text-[36px]">What we are doing</h1>

  <p className="my-4 leading-tight">
    <strong className='font-extrabold'>📊 1. Transparent Record-Keeping and Digital Accountability</strong><br />
    Farmers use the app to track their production, input use, sales, and income—creating verifiable digital records that improve accountability and build trust with buyers, investors, and partners.
  </p>

  <p className="my-4  md:mt-8 mt-4  leading-tight" >
    <strong className='font-extrabold'>🧾 2. Compliance with Standards and Certifications</strong><br />
    FarmNet supports farmers in meeting agricultural standards and sustainability certifications by guiding them on good practices, proper documentation, and ethical production methods.
  </p>

  <p className="my-4 md:mb-6 md:mt-8 mt-4  leading-tight">
    <strong className='font-extrabold'>🗣️ 3. Participation in Decision-Making and Policy Dialogue</strong><br />
    Through farmer groups and data collection tools, FarmNet gives farmers a collective voice in shaping local development programs and engaging with NGOs, government agencies, and development partners.

  </p>

  <p className="my-4 md:mb-6 md:mt-8 mt-4  leading-tight">
    <strong className='font-extrabold'>🔍 4. Improved Traceability and Supply Chain Governance</strong><br />
    The app enhances traceability from farm to market, enabling better oversight of where produce comes from, how it was grown, and under what conditions—building ethical and responsible supply chains
  </p>

  <p className="my-4 md:mb-11 md:mt-8 mt-4  leading-tight">
    <strong className='font-extrabold'>💼 5. Strengthening Farmer Leadership Structures</strong><br />
    FarmNet helps formalize and support local farmer committees or cooperatives, reinforcing good governance practices such as transparency, inclusive leadership, and effective communication within farming communities.
  </p>
</div>

      <h1 className='md:text-[40px] text-[10px] font-bold md:mt-6 mt-2 md:mb-5 text-[#FDBD26]'>SUSTAINABILITY PRIORITIES </h1>
<EsgDropdown/>

<Percent_Bars/>
<div className="flex justify-between items-start md:mt-12 mt-3">
          <div></div> {/* Empty div to push the button to the right */}
<a href='/EsgPageMore3'>

<div>
            <div className="flex items-center ml-auto pr-3 md:pr-0 md:mb-1">
              <p className="md:text-[16px] text-[5px] bg-[#FFBD26] text-white px-2 md:px-4 md:w-[240px] md:py-[9px] py-[3px] md:rounded-tl-xl rounded-tl-md font-bold md:rounded-bl-xl rounded-bl-md whitespace-nowrap">
              VIEW MORE
              </p>
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745429488/Expand_right_4_yccnyz.png"
                alt="Expand"
                className="w-[20px] h-[5px] md:h-[42px] md:w-[55px] hidden md:flex object-contain md:rounded-tr-xl rounded-tr-md font-bold md:rounded-br-xl bg-[#152C24] px-2 md:py-2"
              />
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744370865/Expand_right_5_l2cjmf.png"
                alt="Expand"
                className="w-[20px] h-[13px] md:hidden flex py-[1px] md:h-[42.3px] md:w-[57px] object-contain md:rounded-tr-xl rounded-tr-md font-bold md:rounded-br-xl rounded-br-md bg-[#152C24] md:px-2 px-[2px] md:py-1"
              />
            </div>
            
          </div>
</a>
        </div>
<div className="flex justify-between  items-center border-b border-[#979797] md:mt-20 md:py-10  py-2 md:px-5 px-3 md:space-x-5 flex-wrap rounded-md shadow-lg">
        <div className="text-left text-xl sm:text-xl lg:text-2xl font-semibold">
          <h1 className='font-bold text-[10px] md:text-[32px] '>SDG No 13</h1>
          <h1 className="md:mt-3  -mt-4 text-[6px] md:text-[32px] font-medium">Take urgent action to combat climate change and its impacts</h1>
        </div>
        <div className="md:w-20">
          <img src='https://res.cloudinary.com/dzngpgki4/image/upload/v1745280679/image_44_ircbsd.png' alt="Climate Action" className="md:w-full md:h-auto w-[20px] h-[20px]" />
        </div>
      </div>
      <div className='md:h-5 h-2'></div>
      </div>
    </div>
  );
};

export default EsgPage3;
